
  <tds-modal size="sm" closeIconButtonLabel="Close">
    <tds-modal-title>Subscribe for notifications</tds-modal-title>

    <form [formGroup]="subscriptionForm" class="horizontal-content gap-xs">

      <ng-template #regionTooltip>Price zone could be a country, a bidding zone, a hub, a load zone, a node.</ng-template>
      <tds-form-field class="min-width-md">
        <tds-form-field-label>Price zone <tds-icon name="info" size="xs" [tds-tooltip-target]="regionTooltip" class="label-icon help"></tds-icon></tds-form-field-label>
        <tds-dropdown tds-form-field-item formControlName="zone"
          [items]="regionsOptions()">
          Select a zone
        </tds-dropdown>
      </tds-form-field>

      <div style="padding-top: 25px" class="bold">AND/OR</div>

      <ng-template #sourceTooltip>Source is the publisher of the data. It could be internal or external and the use of the data can be subject to specific rules. Select 'LT Internal Ref'. if you want internal scenarios to be used for investment economics in your Dossier.</ng-template>
      <tds-form-field class="min-width-md">
        <tds-form-field-label>Source <tds-icon name="info" size="xs" [tds-tooltip-target]="sourceTooltip" class="label-icon help"></tds-icon></tds-form-field-label>
        <tds-dropdown tds-form-field-item formControlName="source"
                      [items]="sourcesOptions()">
          Select a source
        </tds-dropdown>
      </tds-form-field>
      <button tds-button variant="secondary" (click)="subscribeToNotification()" (keyup)="subscribeToNotification()" [disabled]="!isSubscriptionAllowed()" class="pointer" style="margin-top: 30px"><tds-icon name="add"></tds-icon></button>
    </form>
    <hr>
    <section>
      <table style="width:100%">
          <thead>
          <tr>
              <th style="width:90%"></th>
              <th style="width:10%"></th>
          </tr>
          </thead>
        @for(subscription of mapSubcriptionIdsWithHisRegionAndSource(); track subscription.id) {
          <tr style="width:100%">
            <td style="width:90%">{{ subscription.description }}</td>
            <td style="width: 10%"><button tds-button variant="tertiary" (click)="unsubscribeToNotification(subscription)" (keyup)="unsubscribeToNotification(subscription)"><tds-icon name="delete"></tds-icon></button></td>
          </tr>
        } @empty {
          <tr>
            <td>no subscriptions</td>
          </tr>
        }
      </table>
    </section>

    <tds-modal-actions>
      <button tds-button variant="tertiary" (click)="close('cancel')" (keyup)="close('cancel')">Cancel</button>
      <button tds-button (click)="subscribeToNotificationAndCloseModal()" (keydown.enter)="subscribeToNotification()" [disabled]="!isSubscriptionAllowed()">Subscribe</button>
    </tds-modal-actions>
  </tds-modal>
